import type { Dispatch, SetStateAction } from 'react';
import { createContext } from 'react';

export interface AuthContextType {
  isAuthenticated: boolean;
  setAuthInfo?: Dispatch<SetStateAction<AuthContextType>>;
}

export const AuthContext = createContext<AuthContextType | null>(null);
